import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue";
var _hoisted_1 = {
    class: "tabbar hg100",
    style: { "border-top": "1px solid #E5E5E5", "width": "100vw" }
};
var _hoisted_2 = { class: "flexRow-alc hg100" };
var _hoisted_3 = ["onClick"];
var _hoisted_4 = { class: "flexColumn-alc" };
var _hoisted_5 = ["src"];
import { onMounted, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
export default /*@__PURE__*/ _defineComponent({
    __name: 'tabbar',
    props: {
        lists: {
            type: Array,
            default: function () { return []; }
        }
    },
    setup: function (__props) {
        var router = useRouter();
        var route = useRoute();
        var store = useStore();
        var handleJump = function (item) {
            if (route.path == item.route || route.path == item.other)
                return;
            router.replace(item.route);
        };
        var version_dic = computed(function () {
            return store.state.version_dic;
        });
        onMounted(function () {
            store.dispatch('getAndroidVresion');
            window.setAndroidVersion = function (event) {
                store.commit('setVersionDic', event);
            };
        });
        return function (_ctx, _cache) {
            var _component_el_badge = _resolveComponent("el-badge");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("section", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.lists, function (item, index) {
                        return (_openBlock(), _createElementBlock("aside", {
                            key: index,
                            style: _normalizeStyle({ width: "".concat(100 / __props.lists.length, "%") }),
                            class: "flexColumn-alc",
                            onClick: function ($event) { return (handleJump(item)); }
                        }, [
                            _createVNode(_component_el_badge, {
                                value: version_dic.value.status && item.isNew ? '新版本' : '',
                                color: "#FC3E39"
                            }, {
                                default: _withCtx(function () { return [
                                    _createElementVNode("div", _hoisted_4, [
                                        _createElementVNode("img", {
                                            src: _ctx.$route.path == item.route || _ctx.$route.path == item.other ? item.iconActive : item.icon,
                                            style: { "width": "30px", "height": "30px", "margin-bottom": "4px" }
                                        }, null, 8, _hoisted_5),
                                        _createElementVNode("span", {
                                            class: _normalizeClass(["ft12", { h_color: _ctx.$route.path == item.route || _ctx.$route.path == item.other }])
                                        }, _toDisplayString(item.name), 3)
                                    ])
                                ]; }),
                                _: 2
                            }, 1032, ["value"])
                        ], 12, _hoisted_3));
                    }), 128))
                ])
            ]));
        };
    }
});
